import React from 'react';

const SectionNavigationDots = ({
  sections,
  activeSection,
  onSectionClick,
  className = ''
}) => {
  return (
    <nav
      role="navigation"
      aria-label="Page sections navigation"
      className={`fixed right-4 sm:right-6 md:right-8 top-1/2 -translate-y-1/2 z-40 hidden md:block ${className}`}
    >
      <div className="flex flex-col gap-3 sm:gap-4 p-2">
        {sections.map((section, index) => (
          <button
            key={section.id || index}
            onClick={() => onSectionClick(index)}
            aria-label={`Go to ${section.label}`}
            aria-current={activeSection === index ? 'true' : 'false'}
            title={section.label}
            className="group relative"
          >
            {/* Touch target (48x48px minimum) */}
            <div className="w-12 h-12 flex items-center justify-center">
              {/* Actual dot */}
              <div
                className={`
                  rounded-full transition-all duration-300 ease-in-out
                  ${activeSection === index
                    ? 'w-3 h-3 sm:w-3.5 sm:h-3.5 bg-gradient-to-br from-indigo-400 to-purple-400 shadow-lg shadow-indigo-500/50'
                    : 'w-2 h-2 sm:w-2.5 sm:h-2.5 bg-slate-500/30 group-hover:bg-slate-400/50 group-hover:scale-110'
                  }
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900
                `}
              />
            </div>

            {/* Desktop tooltip (hidden on mobile) */}
            <span className="
              hidden md:block
              absolute right-full mr-3 top-1/2 -translate-y-1/2
              px-3 py-1.5 rounded-lg
              bg-slate-800/90 backdrop-blur-sm border border-slate-700/50
              text-slate-300 text-sm whitespace-nowrap
              opacity-0 group-hover:opacity-100
              transition-opacity duration-200
              pointer-events-none
            ">
              {section.label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default SectionNavigationDots;
